import React from "react";

import InfoBox from "common-ui-components/components/info-box/InfoBox";
import BarPercentChart from "common-ui-components/components/bar-percent-chart/BarPercentChart";

const licenseSummaryTemplate = [
  {
    id: "License In-Compliance",
    percent: 63,
    color: "#3174A0",
    value: "6.3K",
  },
  {
    id: "Over License",
    percent: 52,
    color: "#B0D062",
    value: "5.2K",
  },
  {
    id: "Under License",
    percent: 47,
    color: "#73C5C5",
    value: "4.7K",
  },
  {
    id: "License Expired",
    percent: 19,
    color: "#ECC353",
    value: "3.2K",
  },
];

const SoftwareLicenseSummary = ({ licenseSummary }) => {
  const newLicenseSummary = licenseSummaryTemplate.map((item) => ({
    ...item,
    percent: licenseSummary[item.id].percent || 0,
    value: licenseSummary[item.id].value || 0,
  }));
  // console.log("It is working ???")
  // console.log(newLicenseSummary)

  return (
    <InfoBox
      header="Software License Summary"
      // style={{ maxWidth: "max-content" }}
    >
      <BarPercentChart
        data={newLicenseSummary}
        height="18.5rem"
        // width="25.7rem"
        topLineFromTop="9%"
        bottomLineFromBottom="5.5%"
        legend
      />
    </InfoBox>
  );
};

export default SoftwareLicenseSummary;
